import React, { Component } from 'react';
import Image from "react-graceful-image";
import './App.css'

class FeatureBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			featureImageAlignRight: props.featureImageAlignRight,
			tallTitle: props.tallTitle,
			featureImage: props.featureImage,
			titleImage: props.titleImage,
			body: props.body,
			primaryLink: props.primaryLink
		};
	}

	featureImageElement() {
		return <a href={this.state.primaryLink}><Image src={this.state.featureImage} noLazyLoad="true" placeholderColor="#000" className="Feature-box-image" alt="" /></a>
	}

	textElement() {
		if (this.state.tallTitle) {
			return (<div className="Feature-box-text">
			<a href={this.state.primaryLink}><img src={this.state.titleImage} className="Feature-box-title-image-tall" alt="" /></a>
			<div>{this.state.body}</div>
		</div>);
		}

		return (<div className="Feature-box-text">
			<a href={this.state.primaryLink}><img src={this.state.titleImage} className="Feature-box-title-image" alt="" /></a>
			<div>{this.state.body}</div>
		</div>);
	}

	render() {
		let rightElement;
		let leftElement;
		if (this.state.featureImageAlignRight) {
			leftElement = this.textElement();
			rightElement = this.featureImageElement();
		}
		else {
			leftElement = this.featureImageElement();
			rightElement = this.textElement();
		}

		return (
			<div className="Feature-box">
				{leftElement}
				{rightElement}
			</div>
		);
	}
}

export default FeatureBox;